export function myFun(a) {
    if(a instanceof Array){
        var array = [];
        a.map(item => {
            if(item.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com') != -1){
                var index = item.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
                var items = item.substring(0, index) + "jusewebapp.zmelo.com" + item.substring(index + 39);
                array.push(items)
            }else{
                var index = item.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
                item = item.substring(0, index) +  "jusexcx.zmelo.com" + a.substring(index + 36);
                array.push(items)
            }
        })
        return array;
    }else{
        if (a.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com') != -1) {
            var index = a.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
            return a.substring(0, index) + "jusewebapp.zmelo.com" + a.substring(index + 39);
        }
        if (a.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com') != -1) {
            var index = a.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
            return a.substring(0, index) +  "jusexcx.zmelo.com" + a.substring(index + 36)
        }
    }
} 


// WEBPACK FOOTER //
// src/plug/modifyImagePath.js